import React from 'react';
import { ExternalProduct } from '../../../../../models/product/types';
import { ActivitiesName } from '../../../../../models/projectActivity/enums';
import { LiveGuidelineActivity } from '../../../../../redux/actions/liveGuidelineActions/types';
import { ActivityAuthor, ActivityProductLink, ActivityRestoreLink, ActivityRow, ActivityText } from './NotificationsTab.styles';

export interface NotificationProduct {
    productId: number;
    externalProduct?: ExternalProduct;
}
interface NotificationActivityRowProps {
    activity: LiveGuidelineActivity;
    authorName: string;
    liveGuidelineName: string;
    index: number;
    product?: NotificationProduct;
    onRestore: (productId: number) => void;
}

const SYSTEM_AUTHOR = 'system';

const isRestorableActivity = (activity: LiveGuidelineActivity): boolean =>
    activity.activityName.toLowerCase() === 'producthidden';

const getActivityLabel = (activityName: string): string =>
    (ActivitiesName as Record<string, string>)[activityName] ?? activityName;

const NotificationActivityRow: React.FC<NotificationActivityRowProps> = ({
    activity,
    authorName,
    liveGuidelineName,
    index,
    product,
    onRestore,
}) => {
    const resolvedAuthorName = activity.authorName || authorName;
    const displayAuthorName =
        resolvedAuthorName.toLowerCase() === SYSTEM_AUTHOR ? liveGuidelineName : resolvedAuthorName;
    const restoredDate = activity.restoredOn
        ? new Date(activity.restoredOn).toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
              timeZone: 'UTC',
          })
        : null;

    return (
        <ActivityRow key={activity.id ?? index}>
            <ActivityAuthor>{displayAuthorName}</ActivityAuthor>
            <ActivityText>{getActivityLabel(activity.activityName)}</ActivityText>
            {product?.externalProduct?.productName && (
                <ActivityProductLink
                    href={product.externalProduct.transparencyCatalogUrl || '#'}
                    target="_blank"
                    rel="noreferrer"
                >
                    {product.externalProduct.company && `${product.externalProduct.company} `}
                    {product.externalProduct.productName}
                </ActivityProductLink>
            )}
            {product && isRestorableActivity(activity) && (
                restoredDate ? (
                    <ActivityText>(restored {restoredDate})</ActivityText>
                ) : (
                    <ActivityRestoreLink
                        href="#"
                        onClick={(event) => {
                            event.preventDefault();
                            onRestore(product.productId);
                        }}
                    >
                        [restore]
                    </ActivityRestoreLink>
                )
            )}
        </ActivityRow>
    );
};
export default NotificationActivityRow;
